import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Post from "../../../Apis/backlink/Post";
import "./style.css";
import { getAPIUrlBM } from "../../../utils/config";

const ShowLogs = ({ linkId }) => {
  const [logs, setLogs] = useState([]);
  const fetchData = async () => {
    try {
      const url = getAPIUrlBM();
      const response = await Post(`${url}/getlogsfromlinkid`, {
        linkId,
      });
      setLogs(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [linkId]);
  console.log({ linkId, type: typeof linkId });

  return (
    <div className="logs">
      <div className="log-row">
        <div className="log-col">
          <label className="gridItemInTableHeader logHeader">Date</label>
        </div>
        <div className="log-col">
          <label className="gridItemInTableHeader logHeader">Rel Tag Status</label>
        </div>
        <div className="log-col">
          <label className="gridItemInTableHeader logHeader">Anchor Status</label>
        </div>
        <div className="log-col">
          <label className="gridItemInTableHeader logHeader">Error Code</label>
        </div>
        <div className="log-col">
          <label className="gridItemInTableHeader logHeader">Link Status</label>
        </div>
      </div>
      {logs && logs.map((log, i) => {
        return (
          <div key={i} className="log-row">
            <div className="log-col">
              <div className="" >{new Date(log?.create_date).toLocaleDateString()}</div>
            </div>
            <div className="log-col">
              <div className="">{log?.rel_tag_status || '----'}</div>
            </div>
            <div className="log-col">
              <div className="">{log?.anchor_status || '----'}</div>
            </div>
            <div className="log-col">
              <div className="">{log?.error_code || "----"}</div>
            </div>
            <div className="log-col">
              <p
                className={
                  log?.link_status?.toUpperCase() === "PRESENT"
                    ? "successStatus  hollowStatus status"
                  : log?.link_status?.toUpperCase() == "OK"
                    ? "okStatus  hollowStatus status"
                  : log?.link_status?.toUpperCase() == "ABSENT"
                    ? "absentStatus  hollowStatus status"
                  : log?.link_status?.toUpperCase() == "ERROR"
                    ? "errorStatus hollowStatus  status"
                  : "notCheckedStatus hollowStatus  status"
                }
              >
                {log?.link_status}
              </p>
            </div>
          </div>
        );
      })}
      {logs && logs.length === 0 && <div className="noLogs">No Logs Found</div>}
    </div>
  )
};

export default ShowLogs;